import { useRouter } from 'next/router'

import { Header } from 'app/KinerjaShared/components/Header'
import CardStepsPenilaianKinerja from 'app/KinerjaDinasPage/components/CardPenilaianKinerjaSteps'
import CardProgresPelaksanaan from 'app/KinerjaDinasPage/components/CardProgresPelaksanaan'

import type { FC } from 'react'

interface PelaksanaanProps {}

const Pelaksanaan: FC<PelaksanaanProps> = ({}) => {
  const router = useRouter()

  return (
    <>
      <div>
        <Header
          title="Pelaksanaan Kinerja"
          className="mb-9 print:hidden"
          onBack={() => {
            router.back()
          }}
        />

        <section className="space-y-6">
          <CardStepsPenilaianKinerja />

          <CardProgresPelaksanaan />
        </section>
      </div>
    </>
  )
}

export default Pelaksanaan
